module.exports = __webpack_public_path__ + "img/bazaar.a2ef3b62.svg";